import { render, staticRenderFns } from "./ServiceOrderSummaryComponent.vue?vue&type=template&id=369437e4&"
import script from "./ServiceOrderSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderSummaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports